import { HcAvatar } from '@hotmart-org-ca/cosmos-web/dist/react/hc-avatar'
import { HcStructureHeader } from '@hotmart-org-ca/cosmos-web/dist/react/hc-structure'
import { dark } from '@space-core/styles/themes'
import { CustomColorsUtils } from '@space-core/utils/colors'
import styled, { css } from 'styled-components'

import { SessionMode } from '../../enum'
import type { Theme } from '../types'

export const HcHeader = styled(HcStructureHeader)<{
  $session: SessionMode
  $isClassRoom: boolean
  $theme?: Theme
}>`
  display: block;
  position: ${({ $session }) => ($session === SessionMode.DEFAULT ? 'fixed' : 'absolute')};
  z-index: 8;
  width: 100%;
  --hc-structure-header-height: 4.5rem;

  ${({ $theme, $isClassRoom }) =>
    $theme === dark.title
      ? `
      --hc-structure-header-z-index: 100;
      --hc-structure-header-black-border-bottom: 1px solid ${
        $isClassRoom
          ? 'var(--gray-300)' // Força gray-300 quando é classroom
          : 'rgba(25,28,31,0)'
      };
      background: 'rgba(14, 16, 18, 1)'
      transition: background .4s;
      transition-timing-function: ease-in;
    `
      : `
      --hc-structure-header-background-color: rgba(255, 255, 255, 1);
      --hc-structure-header-border-bottom: 1px solid ${
        $isClassRoom ? 'var(--gray-300)' : 'var(--gray-200)'
      };
      box-shadow: ${$isClassRoom ? 'none' : '0 0.25rem 1.875rem rgba(112, 119, 128, 0.1)'};
    `}
`

export const Avatar = styled(HcAvatar)<{ $isFixedColor?: boolean }>`
  ${({ color, $isFixedColor }) => css`
    --hc-avatar-background-image: none;
    --hc-avatar-display-name-background: ${$isFixedColor ? 'var(--custom-color-lightest)' : color};
    --hc-avatar-color: ${$isFixedColor
      ? 'var(--gray-900)'
      : CustomColorsUtils.getBestContrastColor(color)};
  `}
`

export const burgerStyles = css`
  .hc-structure-header__burger {
    --hc-button-neutral-tertiary-hover-background-color: var(--gray-200) !important;
    --hc-button-neutral-tertiary-hover-border-color: var(--gray-700) !important;
    --hc-button-neutral-tertiary-focus-background-color: var(--gray-200) !important;
    --hc-button-neutral-tertiary-focus-border-color: var(--gray-700) !important;
  }

  .hc-structure-header__burger-icon {
    color: var(--gray-900);
  }
`
